export default __webpack_public_path__ + "content/media/4.39d6ffea.jpg";